import * as axios from "axios";


let instance = axios.create({
    withCredentials: true,
    baseURL: 'https://social-network.samuraijs.com/api/1.0/',
    headers: {
        "API-KEY": "c75fab8c-07b2-48de-b96f-7ea9c12f7a60",
        //"API-KEY": "7fef31c4-48f9-4c72-b1ed-2e27ab47fadb"
    }
});

export const profileAPI = {
    getProfile(userId) {
        return instance.get('profile/' + userId).then(response => response.data)
    },
    getStatus(userId) {
        return instance.get('profile/status/' + userId).then(response => response.data)
    },
    putStatus(newStatus) {
        return instance.put('profile/status', {status: newStatus}).then(response => response.data)
    },
    putProfile(profile) {
        return instance.put('profile', profile).then(response => response.data)
    },
    setImageProfile(img) {
        let formData = new FormData();
        formData.append("image", img);
        return instance.put('profile/photo', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(response => response.data)
    }
};

export const authAPI = {
    me() {
        return instance.get('auth/me').then(response => response.data)
    },
    login({email, password, rememberMe=false, captcha=false}) {
        return instance.post('auth/login', {email, password, rememberMe, captcha}).then(response => response.data)
    },
    logOut() {
        return instance.delete('auth/login').then(response => response.data)
    },
    captcha() {
        return instance.get('security/get-captcha-url').then(response => response.data)
    }
};

export const usersAPI = {
    getUser(activePage, pageSize, term="") {
        return instance.get(`users?page=${activePage}&count=${pageSize}&term=${term}`).then(response => response.data)
    },
    follow(id) {
        return instance.post('follow/' + id).then(response => response.data)
    },
    unFollow(id) {
        return instance.delete('follow/' + id).then(response => response.data)
    },
    getFollow(id) {
        return instance.get('follow/' + id).then(response => response.data)
    },
};

export const friendsAPI = {
    getFriends(activePage, pageSize, term="") {
        return instance.get(`users?page=${activePage}&count=${pageSize}&friend=true&term=${term}`).then(response => response.data)
    }
};